import {KecPath, Service, Version, source} from './constants';

export const DescribeLocalVolumes = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'DescribeLocalVolumes',
        Service,
        Version,
        source
    }
};
export const validLocalImageSupport = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'ValidLocalImageSupport',
        Service,
        Version,
        source
    }
};
export const DescribeEbsVolumes = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'DescribeEbsVolumes',
        Service,
        Version,
        source
    }
};
export const createLocalSnap = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'CreateLocalVolumeSnapshot',
        Service,
        Version,
        source
    }
};
export const getLocalSnapLists = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'DescribeLocalVolumeSnapshots',
        Service,
        Version,
        source
    }
};

export const diskMonitor = {
    method: 'get',
    basePath: '/monitorapi/dashboard/kecsummarydefault/get',
    params: {
        Service,
        source
    }
};

export const monitorScreen = {
    method: 'get',
    basePath: '/newmonitorapi',
    params: {
        Action: 'DescribeScreen',
        Version: '2021-01-01',
        Service: 'monitor'
    }
};

export const metricsData = {
    method: 'post',
    basePath: '/newmonitorapi',
    params: {
        Action: 'DescribeMetricsData',
        Version: '2022-01-01',
        Service: 'monitor'
    }
};